import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { simplePointerEventsData } from '../../../helpers/util'

class InputRange extends PureComponent {
  static defaultProps = {
    initActiveTrackPos: 0,
    roundBy: 100,
  }

  static propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    initActiveTrackPos: PropTypes.number,
    roundBy: PropTypes.number,
    onFocus: PropTypes.func,
    disabled: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      thumbPos: 0,
      activeTrackStart: 0,
      activeTrackWidth: 0,
      rangeX: 0,
      scale: 0,
      coefficient: 0,
      clicked: false,
    }

    this.rangeRef = React.createRef()
    this.thumbRef = React.createRef()
    this.trackRef = React.createRef()
    this.activeTrackRef = React.createRef()
  }

  componentDidMount() {
    const { min, max } = this.props
    const scale = (this.rangeRef.current.offsetWidth - this.thumbRef.current.offsetWidth) / (Math.abs(min) + max)
    this.setState({ clicked: false })

    this.initial(scale)

    this.rangeRef.current.addEventListener(simplePointerEventsData.pointerdown, this.onPointerDown)
    window.addEventListener(simplePointerEventsData.pointerup, this.removeThumbMove)
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props

    if (prevProps.value !== value) {
      const { min, max } = this.props
      const scale = (this.rangeRef.current.offsetWidth - this.thumbRef.current.offsetWidth) / (Math.abs(min) + max)

      this.initial(scale)
    }
  }

  onPointerDown = (e) => {
    this.updateValue(e)

    window.addEventListener(simplePointerEventsData.pointermove, this.updateValue)
  }

  removeThumbMove = () => {
    setTimeout(() => {
      if (this.props.onFocus) this.props.onFocus(false)
    })

    this.setState({ clicked: false })

    window.removeEventListener(simplePointerEventsData.pointermove, this.updateValue)
  }

  componentWillUnmount() {
    this.setState({ clicked: false })
    this.rangeRef.current.removeEventListener(simplePointerEventsData.pointerdown, this.onPointerDown)
    window.removeEventListener(simplePointerEventsData.pointerup, this.removeThumbMove)
  }

  initial = (scale) => {
    const { value, min, max, initActiveTrackPos } = this.props

    let coefficient = this.thumbRef.current.offsetWidth / 2
    coefficient = initActiveTrackPos === min ? 0 : coefficient
    coefficient = initActiveTrackPos === max ? this.thumbRef.current.offsetWidth : coefficient

    this.updateThumb(value, scale, coefficient)
    this.setState({ scale, coefficient })
  }

  updateValue = (event) => {
    if (this.props.onFocus) this.props.onFocus(true)
    const clientX = simplePointerEventsData.isTouch ? event.touches[0].clientX : event.clientX
    const { scale, coefficient, clicked } = this.state
    const { min, max, roundBy, onChange, onClick, disabled } = this.props
    if (disabled) return

    this.setState(() => ({ clicked: true }))

    const { left: rangeX } = this.rangeRef.current.getBoundingClientRect()

    let value = (clientX - rangeX) / scale - Math.abs(min)
    value = Math.round((value - this.thumbRef.current.offsetWidth / 2 / scale) * roundBy) / roundBy
    value = value <= min ? min : value
    value = value >= max ? max : value

    if (!clicked) onClick(value)
    if (clicked) onChange(value)

    this.updateThumb(value, scale, coefficient)
  }

  updateThumb = (value, scale, coefficient) => {
    const { min, initActiveTrackPos } = this.props

    const thumbPos = (value + Math.abs(min)) * scale
    const activeTrackEnd = thumbPos + this.thumbRef.current.offsetWidth / 2
    let activeTrackStart = (initActiveTrackPos + Math.abs(min)) * scale + coefficient
    let activeTrackWidth = activeTrackEnd - activeTrackStart
    if (activeTrackWidth < 0) {
      activeTrackWidth = activeTrackStart - activeTrackEnd
      activeTrackStart = activeTrackEnd
    }

    this.setState({ thumbPos, activeTrackStart, activeTrackWidth })
  }

  render() {
    const { activeTrackStart, activeTrackWidth, thumbPos } = this.state
    const { min, max, initActiveTrackPos, disabled } = this.props
    const activeTrackRoundLeft = min === initActiveTrackPos ? 'active-track_round-left' : ''
    const activeTrackRoundRight = max === initActiveTrackPos ? 'active-track_round-right' : ''

    return (
      <div className={`range${disabled ? ' range_disabled' : ''}`} ref={this.rangeRef}>
        <div className="track" ref={this.trackRef} />
        <div
          className={`active-track ${activeTrackRoundLeft} ${activeTrackRoundRight}`}
          style={{ left: `${activeTrackStart}px`, width: `${activeTrackWidth}px` }}
          ref={this.activeTrackRef}
        />
        <div
          className={`thumb${disabled ? ' thumb_disabled' : ''}`}
          style={{ left: `${thumbPos}px` }}
          ref={this.thumbRef}
        />
      </div>
    )
  }
}

export default InputRange
